import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=4bacf313&scoped=true"
import script from "./change-password.ts?vue&type=script&lang=ts&external"
export * from "./change-password.ts?vue&type=script&lang=ts&external"
import style0 from "./change-password.scss?vue&type=style&index=0&id=4bacf313&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bacf313",
  null
  
)

export default component.exports